import { createRoot } from 'react-dom/client'
import { I18nextProvider } from 'react-i18next'
import { QueryClientProvider } from 'react-query'
import { Provider } from 'react-redux'
import i18next from 'i18next'
import LngDetector from 'i18next-browser-languagedetector'
import { LicenseInfo } from '@mui/x-license'
import './instrument'
import './suppress-resize-observer-error'
import 'core-js/stable'
import 'regenerator-runtime/runtime'
import './index.css'
import './global.css'
import 'react-toastify/dist/ReactToastify.css'
import 'react-big-calendar/lib/css/react-big-calendar.css'
import { App } from './App'
import { BrowserRouter } from './BrowserRouter'
import ScrollToTop from './components/Common/ScrollToTop'
import { Locales } from './enums'
import { saveLocale } from './helpers/utils'
import { VesselQueryClient } from './query-config'
import { unregister } from './registerServiceWorker'
import { store } from './store/store'
import bo_transaltions from './translations/bo/base.json'
import bo_translation_boat from './translations/bo/boat.json'
import bo_translation_common from './translations/bo/common.json'
import bo_translation_create from './translations/bo/create.json'
import bo_translation_deadlines from './translations/bo/deadlines.json'
import bo_translations_forms from './translations/bo/forms.json'
import bo_translations_screen_info from './translations/bo/screen-info.json'
import bo_translation_sidebar from './translations/bo/sidebar.json'
import bo_validator from './translations/bo/validator.json'
import en_translations from './translations/en/base.json'
import en_translation_boat from './translations/en/boat.json'
import en_translation_common from './translations/en/common.json'
import en_translation_create from './translations/en/create.json'
import en_translation_deadlines from './translations/en/deadlines.json'
import en_translations_forms from './translations/en/forms.json'
import en_translations_screen_info from './translations/en/screen-info.json'
import en_translation_sidebar from './translations/en/sidebar.json'
import en_validator from './translations/en/validator.json'
import nor_transaltions from './translations/no/base.json'
import no_translation_boat from './translations/no/boat.json'
import no_translation_common from './translations/no/common.json'
import no_translation_create from './translations/no/create.json'
import no_translation_deadlines from './translations/no/deadlines.json'
import no_translations_forms from './translations/no/forms.json'
import no_translations_screen_info from './translations/no/screen-info.json'
import no_translation_sidebar from './translations/no/sidebar.json'
import no_validator from './translations/no/validator.json'

const rootElement = document.getElementById('root')
const root = createRoot(rootElement)

i18next.use(LngDetector).init({
  interpolation: { escapeValue: false }, // React already does escaping
  fallbackLng: 'nb',
  debug: false,
  nsSeparator: ':',
  resources: {
    nb: {
      ...nor_transaltions,
      common: no_translation_common,
      boat: no_translation_boat,
      sidebar: no_translation_sidebar,
      deadlines: no_translation_deadlines,
      create: no_translation_create,
      screen_info: no_translations_screen_info,
      validator: no_validator,
      forms: no_translations_forms,
    },
    en: {
      ...en_translations,
      common: en_translation_common,
      boat: en_translation_boat,
      sidebar: en_translation_sidebar,
      deadlines: en_translation_deadlines,
      create: en_translation_create,
      screen_info: en_translations_screen_info,
      validator: en_validator,
      forms: en_translations_forms,
    },
    bo: {
      ...bo_transaltions,
      common: bo_translation_common,
      boat: bo_translation_boat,
      sidebar: bo_translation_sidebar,
      deadlines: bo_translation_deadlines,
      create: bo_translation_create,
      screen_info: bo_translations_screen_info,
      validator: bo_validator,
      forms: bo_translations_forms,
    },
  },
})

const language = localStorage.getItem('language')
const acceptedLanguages = ['nb', 'en', 'bo']
if (language === null || !acceptedLanguages.includes(language)) {
  saveLocale(Locales.nb.value)
  i18next.changeLanguage(Locales.nb.value)
} else {
  i18next.changeLanguage(language)
  saveLocale(language)
}
LicenseInfo.setLicenseKey(
  '0c30cf0b99a163dbb409cac5c9010592Tz0xMTQ1NTQsRT0xNzgxMzk1MTk5MDAwLFM9cHJlbWl1bSxMTT1zdWJzY3JpcHRpb24sUFY9aW5pdGlhbCxLVj0y',
)
root.render(
  <QueryClientProvider client={VesselQueryClient}>
    {/*@ts-ignore*/}
    <Provider store={store}>
      <BrowserRouter>
        <I18nextProvider i18n={i18next}>
          <ScrollToTop />
          <App />
        </I18nextProvider>
      </BrowserRouter>
    </Provider>
  </QueryClientProvider>,
)
unregister()
